module.exports = __webpack_public_path__ + "img/FI22757004.7fb61f0d.png";